/**
 * Service to handle dynamic form integration strategy
 * Provides functions to open forms with Expo integration
 */

var app = angular.module('leonardo');

app.factory('DynamicFormProviderService', [
  '$q',
  'ngDialog',
  '$log',
  function($q, ngDialog, $log) {

    var config = {
      allowFallback: true,        // Whether to allow fallback to legacy React form if Expo fails
      expoInitTimeout: 10000,     // Maximum time to wait for Expo to initialize (ms)
      enabled: false              // Whether Expo integration is enabled by default
    };

  /**
   * Open using the Expo integration
   */
  function openExpoForm(options) {
    if (!options.formObj && !options.formDataObj) {
      return $q.reject('Invalid options: both formObj and formDataObj are missing');
    }
    
    var dialogOptions = {
      template: 'views/templates/dialog/task/dynamic-form-expo.html',
      className: 'ngdialog-theme-default ngdialog-dynamic-form ngdialog-dynamic-form-expo',
      controller: 'TaskDynamicFormExpoDialog',
      resolve: {
        formObj: [function() { return options.formObj || {}; }],
        formDataObj: [function() { return options.formDataObj || {}; }]
      },
      data: angular.extend({}, options.data || {}, {
        // Add Expo specific options
        allowFallback: config.allowFallback,
        expoInitTimeout: config.expoInitTimeout,
        workOrdersEnabled: options.workOrdersEnabled || false,
        // Add a fallback function that will be called by the controller if needed
        fallbackCallback: function() {
          if (config.allowFallback) {
            ngDialog.close();
            
            // Return rejected promise to notify caller to handle the fallback
            var deferred = $q.defer();
            setTimeout(function() {
              var error = new Error('Expo integration failed - component should handle fallback');
              deferred.reject(error);
            }, 300);
            return deferred.promise;
          }
        }
      })
    };
    
    if (options.closeCallback) {
      return ngDialog.openConfirm(dialogOptions).then(
        function(result) {
          if (options.closeCallback) {
            options.closeCallback(result);
          }
          return result;
        },
        function(error) {
          return $q.reject(error);
        }
      );
    } else {
      return ngDialog.open(dialogOptions);
    }
  }
  
  /**
   * Open using the React integration
   */
  function openReactForm(options) {
    var dialogOptions = {
      template: 'views/templates/dialog/task/dynamic-form-react.html',
      className: 'ngdialog-theme-default ngdialog-dynamic-form ngdialog-dynamic-form-react',
      controller: 'TaskDynamicFormDialogReact',
      resolve: {
        formObj: [function () {
          return options.formObj;
        }],
        formDataObj: [function () {
          return options.formDataObj;
        }]
      },
      data: options.data,
    };
    
    if (options.closeCallback) {
      return ngDialog.openConfirm(dialogOptions).then(
        function(result) {
          if (options.closeCallback) {
            options.closeCallback(result);
          }
          return result;
        },
        function(error) {
          return $q.reject(error);
        }
      );
    } else {
      return ngDialog.open(dialogOptions);
    }
  }
  
  /**
   * Open a dynamic form
   * @param {Object} options - The options for the form
   */
  function openForm(options) {
      if (options.useExpoIntegration) {
        // Try Expo first, fallback to React if it fails
        return openExpoForm(options).catch(function(error) {
          if (error === 'EXPO_INTEGRATION_FAILED' || 
              error.message === 'Expo integration failed - component should handle fallback') {
            return openReactForm(options);
          }
          return $q.reject(error);
        });
      } else {
        return openReactForm(options);
      }
    }
    
    // Create API object
    var api = {
      /**
       * Open a dynamic form
       * @param {Object} options - The options for the form
       */
      openForm: openForm
    };
  
    return api;
  }
]);